import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-msa',
  templateUrl: './msa.component.html',
  styleUrls: ['./msa.component.css']
})
export class MsaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }
  scrollTo(element: any): void {
    (document.getElementById(element) as HTMLElement).scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
  }
}
